import dlItems from './dlItems';
import pii from './pii';

const root = {
	dlItems,
	pii
};

export default root;
